import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-samples-details-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: SamplesDetailsTabComponent },
  ],
  templateUrl: './samples-details-tab.component.html',
  styleUrl: './samples-details-tab.component.scss',
})
export class SamplesDetailsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('SampleDetails');

  catalogueId = input<string>('');
  productName = input<string>('');

  endpoint = computed(() => {
    const catId = this.catalogueId().trim();
    const prodName = this.productName();
    return catId
      ? `/visits/tables/samples-details/${encodeURIComponent(catId)}?productName=${encodeURIComponent(prodName)}`
      : '/visits/tables/samples-details';
  });

  public async main(): Promise<void> {}
}